export const getImg = (img) => {
	let imgUrl = null;
	try {
		imgUrl = require(`../../assets/imgs/${img}`);
	} catch (e) {
		imgUrl = require(`../../assets/imgs/${img.replace(
			/\/\d{1,}\.svg$/g,
			'/1.svg'
		)}`);
	}
	return imgUrl;
};

export const returnSaneURL = (url) => {
	return url.includes('http') ? url : window['BASE_URL'] + url;
};
